import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getActionInitialData } from './api';
import { QueryKey } from '@behavior/QueryKey';

type UseQueryOptionsKeys = Pick<QueryObserverOptions, 'enabled' | 'retry' | 'onSuccess'>;

export default function useActionInitialData(options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data: actionInitial, isFetching } = useQuery(
    [`${QueryKey.ACTION_INITIAL}`],
    () => getActionInitialData(),
    {
      enabled: true,
      onError: error => {
        toast.error(t('message.title.error.get.action'));
      },
      ...options,
    }
  );

  return { actionInitial, isFetching, getActionInitialData };
}
